module.exports = __webpack_public_path__ + "img/magento-support-security_medium.cb7f4979.jpg";